// Enter / leave enterprise mode. Both directions mint a FRESH token on the
// server and rebuild the store through the shared bootstrap — a stored token is
// never restored (it may predate a membership or ownership change).
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { enterprise as enterpriseApi } from '@/lib/trackizy';
import { uiActions } from '@/store';
import { showToast } from '@/components/shared/Toast';
import { adoptToken } from './sessionBootstrap';

export default function useEnterpriseMode() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const enterEnterprise = useCallback(async () => {
    try {
      const { token } = await enterpriseApi.enter();
      await adoptToken(token, dispatch);
      dispatch(uiActions.setSidebarMode('fleet'));
      navigate('/enterprise');
      return true;
    } catch {
      showToast(t('enterprise.enterFailed', 'Could not open the enterprise view'));
      return false;
    }
  }, [dispatch, navigate, t]);

  const exitEnterprise = useCallback(async () => {
    try {
      const { token } = await enterpriseApi.exit();
      await adoptToken(token, dispatch);
      navigate('/');
      return true;
    } catch {
      showToast(t('enterprise.exitFailed', 'Could not leave the enterprise view'));
      return false;
    }
  }, [dispatch, navigate, t]);

  return { enterEnterprise, exitEnterprise };
}
